<template>
  <div
    class="hide-overflow "
    style="position: relative;"
  >
    <v-toolbar
      app
      dark
      color="primary"
      scroll-off-screen
      scroll-target="#scrolling-techniques"
    >
      <v-toolbar-side-icon @click="backRoute()"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      <v-toolbar-title >{{$store.state.menuName}}</v-toolbar-title>
      <v-spacer></v-spacer>
       <v-tooltip bottom>
      <template v-slot:activator="{ on }">
            <v-btn icon @click="home()" v-on="on">
        <v-icon>dashboard</v-icon>
      </v-btn> 
      </template>
      <span>กลับหน้าแรก</span>
    </v-tooltip>



    </v-toolbar>
  </div>
</template>
<script>
export default {
  name:"appbar",
  data() {
    return {
   };
  },
  methods: {
    backRoute(){
      switch (this.$route.path) {
        case "/view":
          this.$router.replace({ name: "home" });
          break;
        case "/displayData":case "/peopleAge":
          this.$router.replace({ name: "view" });
          break;
        default:
          break;
      }
    },
    home() {
      window.location.href = "https://stat.bora.dopa.go.th/stat/statnew/statMenu/newStat/home.php";
    },
  },
};
</script>